import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.connection', {
        url: '/connection',
        component: 'companyDirectoryIntegrationManageConnection',
        resolve: {
            connectionDetails,
            optionalOnPrem,
            onPremInitialValue,
        }
    });
}

/** @ngInject */
function connectionDetails(companyId, directory, DirectoriesResource) {
    if (directory.agentConnected === 'ACTIVE') {
        return DirectoriesResource.getDirectoryConnectionDetails(companyId, directory.id);
    }
    return null;
}

/** @ngInject */
function optionalOnPrem(connectionDetails) {
	
	return connectionDetails!==null && ((connectionDetails.adAccountPasswordsCanBeEdited===null) || !connectionDetails.adAccountPasswordsCanBeEdited);
}

/** @ngInject */
function onPremInitialValue(optionalOnPrem,directory) {
	if(directory.onPremConnection!== null) {
		return directory.onPremConnection;
	}
	return {onPremisesConnectionEnabled: !optionalOnPrem, adAgentUrl: '', adAgentPublicCertificate: ''};
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/directory-manage-connection.state.js